module.exports = __webpack_public_path__ + "img/conmpany-logo.298f2084.png";